
import {
  defineComponent,
  computed,
} from 'vue';

export default defineComponent({
  props: {
    connect: {
      type: String,
      required: false,
      default: () => 'false',
    },
    type: {
      type: String,
      required: false,
      default: () => 'default',
    },
    spacer: {
      type: String,
      required: false,
      default: () => 'none',
    },
    spacerCloudsPlacement: {
      type: String,
      required: false,
      default: () => 'bottom',
    },
    spacerBarAlign: {
      type: String,
      required: false,
      default: () => 'right',
    },
  },

  setup(props) {
    const connectItems = computed<boolean>(() => props.connect === 'true');

    window.currentListSection = {
      type: props.type,
      count: 0,
    };

    const containerClasses = computed<string[]>(() => {
      const containerClassesComputed: string[] = [];

      if (connectItems.value) {
        containerClassesComputed.push('connect-items');
      }

      return containerClassesComputed;
    });

    return {
      containerClasses,
    };
  },
});
